module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av620-7b88e63a7eb9547d36ba5dfccd6ef79c.jpg";